import styled from 'styled-components'

export default styled.div<{ md?: boolean; header?: boolean }>`
  margin: 0 auto;
  padding: 0 ${({ theme }) => theme.spacing['3XL']};
  width: 100%;

  ${({ md, theme }) =>
    md
      ? `
    padding: 0 ${theme.spacing.L};
    `
      : ''}

  ${({ header, theme }) =>
    header
      ? `
    padding-top: ${theme.spacing.L};
    `
      : ''}
`
